<template>  
  <div class="footer">
      <br/>
      <b-row >      
        <b-col cols="3">
          www.cepe.com.br
        </b-col>
        <b-col cols="5">
          Copyright © Companhia Editora de Pernambuco - CEPE
        </b-col>
        <b-col cols="3">
          {{ company }}
        </b-col>
      </b-row>      
  </div>  
</template>

<script>
export default {
  name: 'user-profile-footer',  
  data() {
    return {
      company: ''
    }
  },
  created() {
    const user = this.$store.getters["auth/user"];
    this.company = user.CompanyName;
  },
  methods: {
    
  }
};
</script>

<style>
  .footer {
    bottom: 0;
    width: 100%;
    padding: 20px;
    background-color: #000000;
    color: #ffffff;
    text-align-last: center;
    padding-top: 0px;
    padding-left: 60px;
  }
</style>
